import { useContext } from "react";
import { ReminderContext } from "../contexts/ReminderContext";
import { IReminderContext } from "../contexts/models/IReminderContextt";

export const useReminder = () => useContext<IReminderContext>(ReminderContext);